const windowScrollTop = () => {
    try {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
    catch (error) {
        // support for older browsers
        window.scrollTo(0, 0);
    }
};
export default windowScrollTop;
